import React from 'react';
import { Card, ListGroup } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const LegalSettingsPage = () => {
    return (
        <Card>
            <Card.Header as="h5">Documentos Legales</Card.Header>
            <Card.Body>
                <Card.Text>
                    Aquí puedes consultar los documentos legales que rigen el uso de Evazard.
                </Card.Text>
                <ListGroup>
                    <ListGroup.Item action as={Link} to="/terms-of-service" target="_blank" rel="noopener noreferrer">
                        Términos y Condiciones de Uso
                    </ListGroup.Item>
                    <ListGroup.Item action as={Link} to="/privacy-policy" target="_blank" rel="noopener noreferrer">
                        Política de Privacidad
                    </ListGroup.Item>
                    <ListGroup.Item action as={Link} to="/dpa" target="_blank" rel="noopener noreferrer">
                        Acuerdo de Procesamiento de Datos (DPA)
                    </ListGroup.Item>
                </ListGroup>
            </Card.Body>
        </Card>
    );
};

export default LegalSettingsPage;
